import './App.css';
import React from "react";
import FormData from './components/FormData/FormData';
import Login from './components/Login/Login';
import { Routes, Route, BrowserRouter } from "react-router-dom";


const userSession = JSON.parse(sessionStorage.getItem('userInfo'))
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/:id" element={<Login />} />
        if(userSession.user === 1) {
          <Route path="/FormData" element={<FormData />} />

        }else{
          <Route exact path="/" element={<Login />} />

        }

      </Routes>
    </BrowserRouter>

  );

}

export default App;
